<template>
  <CModal
    title="Application Status Update"
    color="primary"
    :show.sync="showModal"
    :centered="true"
    size="lg"
    @update:show="onModalClose"
  >
    <div class="px-2">
      <p class="text-muted mb-3">
        <em class="fa fa-bell text-primary mr-2"></em>
        Your application status has been updated for the following job(s):
      </p>

      <div class="d-none d-md-block">
        <table class="table table-bordered table-sm">
          <thead class="thead-light">
            <tr>
              <th>Job ID</th>
              <th>Job Title</th>
              <th>Organisation</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in alertItems" :key="index">
              <td>{{ item.job_display_uid }}</td>
              <td>{{ item.job_title }}</td>
              <td>{{ item.organisation_name }}</td>
              <td>
                <CBadge :color="item.badge_color">
                  {{ item.status_label }}
                </CBadge>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-md-none">
        <div
          v-for="(item, index) in alertItems"
          :key="index"
          class="card mb-2"
        >
          <div class="card-body p-2">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <strong>{{ item.job_display_uid }}</strong>
              <CBadge :color="item.badge_color">
                {{ item.status_label }}
              </CBadge>
            </div>
            <div class="text-sm text-muted">{{ item.job_title }}</div>
            <div class="text-sm text-muted">{{ item.organisation_name }}</div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <CButton color="primary" @click="onModalClose">Close</CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  name: "CandidateLoginAlert",
  props: {
    isShowPopup: {
      type: Boolean,
      default: false,
    },
    alerts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    alertItems() {
      return this.alerts.map((val) => ({
        action_detail_id: val.action_detail_id,
        job_id: val.job_id,
        status_id: val.status_id,
        job_display_uid: val.job?.display_uid || val.job_id || "--",
        job_title: val.job?.job_title || "--",
        organisation_name:
          val.job?.parent_org_info_required && val.job?.parent_org_info?.length
            ? val.job.parent_org_info[0].name
            : val.job?.organisation_name ||
              val.job?.organisation?.name ||
              "--",
        status_label: val.status_display
          ? (val.sub_status_display
              ? `${val.status_display} (${val.sub_status_display})`
              : val.status_display)
          : val.status_id === 42 ? "Matched"
          : val.status_id === 54 ? "Approved for Interview"
          : val.status_id === 67 ? "Hospital Shortlist"
          : val.status_id === 75 ? "Agency Matched"
          : val.status_id === 58
            ? (val.sub_status_id === 60 ? "Offer Accepted" : "Offered")
            : "Recruiter Shortlist",
        badge_color: val.status_id === 42 ? "info"
          : val.status_id === 58 ? "warning"
          : val.status_id === 54 ? "primary"
          : "success",
      }));
    },
  },
  watch: {
    isShowPopup(val) {
      this.showModal = val;
    },
  },
  mounted() {
    this.showModal = this.isShowPopup;
  },
  methods: {
    onModalClose() {
      this.showModal = false;
      this.$emit("close");
    },
  },
};
</script>
